<template>
    <section class="header_second_area">
            <div class="container">
                <div class="row">
                    <div class="col-sm-2">
                        <div class="logo_box">
                            <div class="logo">
                                <router-link tag="a" to="/"><img src="images/logo.png" alt="logo"></router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="rolunk_btn">
                            <div class="rolunk_btn_box">
                                <ul>
                                    <li><router-link tag="a" to="/">WEBSHOP</router-link></li>
                                    <!-- <li><router-link tag="a" to="/">RÓLUNK</router-link></li> -->
                                    <li> <a :href="webstoreLink">RÓLUNK</a> </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-7">
                        <div class="box_search">
                            <div class="box_search_box">
                                <div class="blog_search">
                                    <input type="text" class="best" placeholder="Keresés..." v-model="query" style="height:45px;">
                                    <div class="blog_search_btn"><span class="fa fa-search"></span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
</template>
<script>
export default{
    data:function () {
        return {
            // query:'',
        };
    },
    computed:{
        query:{
            get:function () {
                return this.$store.getters.getSearchQuery;
            },
            set:function (val) {
                this.$store.commit('setSearchQuery',val);
                if(val.length>0){
                    this.$router.push('/list');
                }
            }
        },
        webstoreLink:function () {
            return 'http://borakft.'+(window.testEnv?'myitsolver.com':'hu');
        }
    },
    // methods:{
    //     queryChanged:function () {
    //
    //     }
    // }
}
</script>



// WEBPACK FOOTER //
// Header2.vue?5e9f260f